import { getConfig } from './config'

export type Lab = {
  status: string;
  isDefault: boolean;
  isDeleted: boolean;
  _id: string;
  name: string;
  code: string;
  updatedAt: string;
  createdAt: string;
  __v: number;
  countryCode?: string | null;
  image?: string | null;
  stateCode?: string | null;
}

export const get = async (): Promise<Lab[]> => {
  const config = getConfig()
  const response = await config.axios.get<Lab[]>(`${config.API_URL}/labs`)

  return response.data
}

// export const getOne = async ({ labId }) => {
//   return axios.get(`${config.API_URL}/labs/${labId}`)
// }

// export const save = async ({ labId, ...restData }) => {
//   if (labId) {
//     return axios.put(`${config.API_URL}/labs/${labId}`, restData)
//   }

//   return axios.post(`${config.API_URL}/labs`, restData)
// }

// export const remove = async ({ labId }) => {
//   return axios.delete(`${config.API_URL}/labs/${labId}`)
// }
